import {
  IOverleveringChecklistReport,
  IOverleveringChecklistRow,
  OVERLEVERING_CHECKLIST_TYPES,
  OverleveringChecklistRowDef,
} from "../reportSchemas/startupChecklistSchema";

export const createOverleveringChecklistRows = (
  defs: OverleveringChecklistRowDef[],
): IOverleveringChecklistRow[] =>
  defs.map((row) =>
    row.kind === "SECTION"
      ? {
          nr: row.nr,
          text: row.text,
          kind: "SECTION",
        }
      : {
          nr: row.nr,
          text: row.text,
          kind: "QUESTION",
          answer: null,
          comment: "",
        },
  );

export const OVERLEVERING_CHECKLIST_ROW_DEFS: OverleveringChecklistRowDef[] = [
  {
    nr: "1",
    text: "Multiconsults forpliktelser overfor kunden\n(NB! Pkt. 1.1-1.12 er obligatorisk for oppdrag med Forenklet styring - Nivå 2 og 3.",
    kind: "SECTION",
  },
  {
    nr: "1.1",
    text: 'Er avtale/ordrebekreftelse signert, eller avrop på rammeavtale bekreftet i e-post, tagget og arkivert i mappe 01 Startprodukt? Se lenke til "Veiledning for tagging av signerte avtaledokumenter".',
    kind: "QUESTION",
  },
  {
    nr: "1.2",
    text: "Foreligger signerte internavtaler med eventuelle samarbeidspartnere?",
    kind: "QUESTION",
  },
  {
    nr: "1.3",
    text: "Foreligger signerte avtaler med eventuelle underleverandører eller avtaler der vi er underleverandører?",
    kind: "QUESTION",
  },
  {
    nr: "1.4",
    text: "Er alle avtaledokumenter og skriftlig kommunikasjon fra tilbudsfasen arkivert i mappe 01 Startprodukt i LiveLink?",
    kind: "QUESTION",
  },
  {
    nr: "1.5",
    text: "Er alle avtaledokumenter, inkludert referat fra kontraktsavklaringsmøter, gjennomgått i felleskap av TA og TL og OA og OL?",
    kind: "QUESTION",
  },
  {
    nr: "1.6",
    text: "Er alle forhold i avtale-/kontrakt, inkl. kontraktsbestemmelsene, entydige?",
    kind: "QUESTION",
  },
  {
    nr: "1.7",
    text: "Er avtaledokumentenes innbyrdes rang/rekkefølge avklart?",
    kind: "QUESTION",
  },
  {
    nr: "1.8",
    text: "Er alle forhold som behandles i flere av dokumentene - og der det er motstrid mellom dokumentene - behandlet særskilt?",
    kind: "QUESTION",
  },
  {
    nr: "1.9",
    text: "Er avtalens honorar, honorarformat, honorarfordeling mellom fagene og ytelser entydig beskrevet og forstått? Er det eventuelt diskutert hva vi bør gjøre om dette ikke er tilfellet?",
    kind: "QUESTION",
  },
  {
    nr: "1.10",
    text: "Er prosjektets (oppdragsgivers) fremdriftsplan og krav til våre leveringsfrister avklart?",
    kind: "QUESTION",
  },
  {
    nr: "1.11",
    text: "Har vi avklart når vi trenger eventuelt underlag/beslutninger fra oppdragsgiver?",
    kind: "QUESTION",
  },
  {
    nr: "1.12",
    text: "Er det i tilbudsfasen lagt en strategi for hvordan eventuelle uklare forhold i avtalen/kontrakten skal følges opp i oppdraget?",
    kind: "QUESTION",
  },
  {
    nr: "1.13",
    text: "Er det opprettet referanseprosjekt i CVpartner, samt sendt til oppdragsmedarbeideres CV?",
    kind: "QUESTION",
  },
  {
    nr: "",
    text: "Punktene 1.14-1.25, 2.1-2.5 og 3.1-3.6 nedenfor gjennomgås etter behov (vurderes og besluttes av TA, OA og OL).",
    kind: "SECTION",
  },
  {
    nr: "1.14",
    text: "Er det avklart hvilke deler av oppdraget som er bestilt, og hvilke deler som eventuelt ligger i opsjoner?",
    kind: "QUESTION",
  },
  {
    nr: "1.15",
    text: "Har vi gjennomgått og avstemt eventuelle DAK-/BIM-ambisjoner, med kunden?",
    kind: "QUESTION",
  },
  {
    nr: "1.16",
    text: "Har vi gjennomgått og avstemt eventuelle bærekraftsambisjoner, med kunden?",
    kind: "QUESTION",
  },
  {
    nr: "1.17",
    text: "Er aktuelle dokumenter/tegninger fra tilbudsfasen gjennomgått?",
    kind: "QUESTION",
  },
  {
    nr: "1.18",
    text: "Er gjennomføringsprosessen for oppdraget avklart med kunden? (for eksempel antall møter på ulike områder - se merknad)",
    kind: "QUESTION",
  },
  {
    nr: "1.19",
    text: "Er eventuell entreprisestruktur avklart og gjennomgått?",
    kind: "QUESTION",
  },
  {
    nr: "1.20",
    text: "Gjelder oppdraget en flergangskunde, der det er innarbeidet en uformell praksis?",
    kind: "QUESTION",
  },
  {
    nr: "1.21",
    text: "Er det spesielle utfordringer med denne kunden vi må være oppmerksomme på?",
    kind: "QUESTION",
  },
  {
    nr: "1.22",
    text: "Har vi avklart i tilbudsfasen hva som er viktig for kunden (suksessfaktorer) i forhold til gjennomføring og sluttprodukt?",
    kind: "QUESTION",
  },
  {
    nr: "1.23",
    text: "Har vi lovet/lagt vekt på spesielle forhold i tilbudet? (Se eksempler under merknad).",
    kind: "QUESTION",
  },
  {
    nr: "1.24",
    text: "Har vi hatt en gjennomgang av kundens forventninger til oss?",
    kind: "QUESTION",
  },
  {
    nr: "1.25",
    text: "Er kontaktpersoner hos kunden avklart?",
    kind: "QUESTION",
  },
  {
    nr: "2",
    text: "Multiconsults strategi",
    kind: "SECTION",
  },
  {
    nr: "2.1",
    text: "Har Multiconsult hatt en spesiell strategi for å ønske å vinne dette oppdraget? Se mulige grunner til dette, og aktuelle tiltak, under merknad til cellen.",
    kind: "QUESTION",
  },
  {
    nr: "2.2",
    text: "Er det avklart hvilken enhet som eier oppdraget?",
    kind: "QUESTION",
  },
  {
    nr: "2.3",
    text: "Er prinsipper for eventuelle opp-/ned-skrivinger avtalt dersom flere FE-er er involvert i oppdraget?",
    kind: "QUESTION",
  },
  {
    nr: "2.4",
    text: "Er bemanningsforutsetninger gjennomgått?",
    kind: "QUESTION",
  },
  {
    nr: "2.5",
    text: "Er muligheter for mersalg/merarbeid kartlagt?",
    kind: "QUESTION",
  },
  {
    nr: "3",
    text: "Andre krav og forutsetninger",
    kind: "SECTION",
  },
  {
    nr: "3.1",
    text: "Er usikkerhets-/risikovurdering i tilbudsfasen utført og gjennomgått?",
    kind: "QUESTION",
  },
  {
    nr: "3.2",
    text: "Er deler av avtalen eller noen av våre ytelser forbundet med høy risiko (ansvar, økonomi, omdømme, HMS, SHA, vanskelige byggeforhold, mv.)?",
    kind: "QUESTION",
  },
  {
    nr: "3.3",
    text: "Er det laget en plan/strategi for å håndtere eventuelle forhold med middels/høy risiko?",
    kind: "QUESTION",
  },
  {
    nr: "3.4",
    text: "Er det i tilbudsfasen identifisert andre oppdrag i Multiconsult som kan ha interessekonflikter med dette oppdraget?",
    kind: "QUESTION",
  },
  {
    nr: "3.5",
    text: "Er det behov for supplerende undersøkelser for å få et tilstrekkelig prosjekteringsgrunnlag (kan evt. gi mulighet for mersalg):",
    kind: "QUESTION",
  },
  {
    nr: "3.5.a",
    text: "Er det behov for ytterligere grunnundersøkelser?",
    kind: "QUESTION",
  },
  {
    nr: "3.5.b",
    text: "Er det behov for å finne ut hva som befinner seg i grunnen av ledninger, konstruksjoner, forurensing, fornminner, mv.?",
    kind: "QUESTION",
  },
  {
    nr: "3.5.c",
    text: "Er det behov for avklaring av offentlige krav og forutsetninger (regulering, miljø, mv.)",
    kind: "QUESTION",
  },
  {
    nr: "3.5.d",
    text: "Er det behov for å avklare forhold til naboer og andre interessenter?",
    kind: "QUESTION",
  },
  {
    nr: "3.6",
    text: "Er eventuelle spesielle krav fra OA/styringsgruppe",
    kind: "QUESTION",
  },
];

export const OVERLEVERING_CHECKLIST_INIT_DATA: IOverleveringChecklistReport = {
  overleveringChecklistType: OVERLEVERING_CHECKLIST_TYPES.OVERLEVERING,
  overleveringChecklistMeta: {
    title: "",
    oppdragsnummer: "",
    oppdragsnavn: "",
  },
  rows: createOverleveringChecklistRows(OVERLEVERING_CHECKLIST_ROW_DEFS),
};
